import { useState } from 'react';
import { DisaggregatedMetric } from '../services/types';
import useDeepCompareEffect from './useDeepCompareEffect';
import { orgId } from '../utils/dashboardUtils';
import { indicatorsEnv } from '../utils/environment';

interface GeoDetails {
    lod: string;
    ids: string[]
};

const useFetchAllIndicators = (isOpen: boolean, geoDetails: GeoDetails[]) => {
    const [disaggregatedIndicators, setDisaggregatedIndicators] = useState<DisaggregatedMetric[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    // Add percentCalc to disaggregate call
    const percentCalc = true;
    const geoEncoding = 'delta';

    const disaggregatedUrl = `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdisaggregatedindicators`;

    useDeepCompareEffect(() => {

        if (!isOpen) return;

        const fetchData = async () => {
            try {
                if (orgId !== null) {

                    console.log('Fetching All Indicators...')
                    // Fetch disaggregated data
                    const disaggregatedResponse = await fetch(disaggregatedUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ geoDetails, orgId, percentCalc, geoEncoding, environment: indicatorsEnv }),
                    });

                    if (!disaggregatedResponse.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const disaggregatedResult = await disaggregatedResponse.json();
                    setDisaggregatedIndicators(disaggregatedResult.data);
                }
            } catch (error: any) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [geoDetails, orgId]);

    return { disaggregatedIndicators, loading, error };
};

export default useFetchAllIndicators;